import { render, staticRenderFns } from "./HatsuiTableDisplay.vue?vue&type=template&id=bddb07f2&scoped=true&"
import script from "./HatsuiTableDisplay.vue?vue&type=script&lang=ts&"
export * from "./HatsuiTableDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./HatsuiTableDisplay.vue?vue&type=style&index=0&id=bddb07f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb07f2",
  null
  
)

export default component.exports